import React, { useCallback, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hideCashbackNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import CashbacksPolling from './CashbacksPolling/CashbacksPolling'

const CashbackNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const { all: allCashbackList, hide: hiddenCashbackList } = useSelector(selectNotifies, shallowEqual).cashback

  const [temporarilyClosedCashback, setTemporarilyClosedCashback] = useState<number[]>([])

  const hideNotify = useCallback(
    (id: number) => {
      dispatch(hideCashbackNotify(id))
    },
    [dispatch],
  )

  const temporarilyHideNotify = useCallback(
    (id: number) => {
      hideNotify(id)
      setTemporarilyClosedCashback(prev => [...prev, id])
    },
    [hideNotify],
  )

  const items = useMemo(
    () =>
      Object.keys(allCashbackList)
        .filter(
          cashbackId => !hiddenCashbackList?.includes(+cashbackId) && !temporarilyClosedCashback.includes(+cashbackId),
        )
        .map(cashback => {
          const currID = Number(cashback)
          const amount = allCashbackList[currID]?.amount
          const currency = allCashbackList[currID]?.amountCurrency

          return (
            <NotifyContainer
              key={currID}
              title={locale.yourCashback}
              value={amount}
              currency={currency}
              callback={() => hideNotify(currID)}
              backgroundCallback={() => temporarilyHideNotify(currID)}
            />
          )
        }),
    [
      allCashbackList,
      hiddenCashbackList,
      hideNotify,
      temporarilyHideNotify,
      locale.yourCashback,
      temporarilyClosedCashback,
    ],
  )

  return isAuth ? (
    <>
      <CashbacksPolling />
      {items}
    </>
  ) : null
}

export default CashbackNotify
